// ...existing imports...
import React, { useState, useEffect, useMemo, useRef } from "react";
import "./style.css";
import { internshipRequestsList, internshipQualifications } from "../user.api";
import Loader from "../../../components/loader/loader";
import { Toast } from "bootstrap";
import Pagination from "../../../components/page/companyDirectory/companyPagination";
import jwtDecode from "jwt-decode";
import BreadCrumpBack from "../../../components/navigator/back";

if (typeof process === "undefined") {
  window.process = { env: {} };
}

let PageSize = 9;

export default function InternshipProposalsList(props) {
  const userPayload = props.state.payload ? jwtDecode(props.state.payload) : {};
  const isSubUser =
    userPayload?.actor === "company_user" ||
    userPayload?.user?.is_company_user ||
    userPayload?.is_company_user;
  const isPublicRoute = props.location.pathname.startsWith("/public");
  const [isActive, setIsActive] = useState(false);
  const myRef = useRef(null);
  const [searchData, setSearchData] = useState([]);
  const [pagination, setPagination] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [qualifications, setQualifications] = useState([]);
  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const normalized = String(dateStr).split("T")[0];
    const [year, month, day] = normalized.split("-");

    if (!year || !month || !day) return "N/A";

    return `${day} ${monthNames[Number(month) - 1]} ${year}`;
  };

  const servInstance = process.env.REACT_APP_BASE_URL || "";
  let result = servInstance
    ? servInstance.substring(0, servInstance?.length - 4)
    : "";

  const listData = (page = 1) => {
    setIsActive(true);
    internshipRequestsList(isPublicRoute, { page })
      .then((res) => {
        setSearchData(res?.data || []);
        setPagination(res?.pagination || null);
        setIsActive(false);
      })
      .catch((err) => {
        setIsActive(false);
        Toast.error("Something Went Wrong");
      });
  };

  const mainData = useMemo(() => {
    return searchData;
  }, [searchData]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    listData(page);
    myRef.current.scrollIntoView();
  };

  useEffect(() => {
    listData(currentPage);
  }, [isPublicRoute]);

  useEffect(() => {
    internshipQualifications()
      .then((res) => {
        setQualifications(res?.data || []);
      })
      .catch((err) => {
        setQualifications([]);
      });
  }, []);

  const handleCreateNew = () => {
    props.history.push("/internship-proposals-form");
  };

  const handleViewDetails = (id) => {
    const basePath = isPublicRoute
      ? "/public-internship-proposals"
      : "/internship-proposals";
    props.history.push(`${basePath}/${id}`);
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case "pending":
        return "warning";
      case "approved":
        return "success";
      case "rejected":
      case "initially_rejected":
        return "danger";
      case "submitted":
      case "submitted_for_acceptance":
        return "secondary";
      default:
        return "secondary";
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case "pending":
        return "Pending";
      case "approved":
        return "Approved";
      case "rejected":
        return "Rejected";
      case "initially_rejected":
        return "Reverted";
      case "submitted":
      case "submitted_for_acceptance":
        return "Submitted";
      case "reverted_to_admin":
        return "In Progress";
      default:
        return status || "Unknown";
    }
  };

  const getQualificationName = (id) => {
    const findQual = (items, id) => {
      for (let item of items) {
        if (item.id === id) return item.name;
        if (item.children_recursive) {
          const found = findQual(item.children_recursive, id);
          if (found) return found;
        }
      }
      return null;
    };
    return findQual(qualifications, id);
  };

  const getQualificationNamesFromIds = (ids) => {
    if (!ids) return "--";
    let idList = [];
    if (typeof ids === "string") {
      try {
        idList = JSON.parse(ids);
      } catch (e) {
        idList = ids.split(",").map(Number);
      }
    } else if (Array.isArray(ids)) {
      idList = ids;
    }
    if (!Array.isArray(idList)) return "--";
    const names = idList.map(id => getQualificationName(Number(id))).filter(Boolean);
    return names.length > 0 ? names.join(", ") : "--";
  };

  const getTargetCategoryNB = (category) => {
    if (props.state.language === "ma") {
      switch (category) {
        case "students_undergoing_course":
          return "* കുറിപ്പ്: ഈ ഇന്റേൺഷിപ്പ് കോഴ്സ് പഠിച്ചുകൊണ്ടിരിക്കുന്ന വിദ്യാർത്ഥികൾക്ക് ബാധകമാണ്.";
        case "students_completed_course":
          return "* കുറിപ്പ്: ഈ ഇന്റേൺഷിപ്പ് കോഴ്സ് പൂർത്തിയാക്കിയ വിദ്യാർത്ഥികൾക്ക് ബാധകമാണ്.";
        case "both":
          return "* കുറിപ്പ്: ഈ ഇന്റേൺഷിപ്പ് കോഴ്സ് പൂർത്തിയാക്കിയവർക്കും പഠിച്ചുകൊണ്ടിരിക്കുന്നവർക്കും ബാധകമാണ്.";
        default:
          return "";
      }
    } else {
      switch (category) {
        case "students_undergoing_course":
          return "* NB: This internship is applicable only for students undergoing the course.";
        case "students_completed_course":
          return "* NB: This internship is applicable only for students who have completed the course.";
        case "both":
          return "* NB: This internship is open for both students who have completed the course and those undergoing it.";
        default:
          return "";
      }
    }
  };

  return (
    <div className="tender bg-tender" ref={myRef}>
      <Loader open={isActive} />
      <div>
        <div className="dash-banner ">
          <div className="tit-txt">
            {props.state.language === "ma"
              ? "ഇന്റേൺഷിപ്പ് പ്രൊപ്പോസലുകൾ"
              : "Internship Proposals"}
          </div>
        </div>
      </div>
      <BreadCrumpBack />
      <div className="container-fluid px-4 px-md-5 py-4">
        <div className="res-page-cont">
          <div className="d-flex justify-content-between align-items-center mb-4">
            {!isSubUser && !isPublicRoute && (
              <button className="btn btn-primary" onClick={handleCreateNew}>
                {props.state.language === "ma"
                  ? "+ പുതിയ പ്രൊപ്പോസൽ"
                  : "+ Create New Proposal"}
              </button>
            )}
          </div>

          {pagination && (
            <div className="mb-4 d-flex justify-content-between align-items-center bg-white p-3 rounded shadow-sm border flex-wrap gap-2">
              <div className="text-muted" style={{ fontSize: "13px" }}>
                {props.state.language === "ma" ? (
                  <>
                    ആകെ <span className="font-weight-bold text-dark">{pagination.total || 0}</span> പ്രൊപ്പോസലുകളിൽ <span className="font-weight-bold text-dark">{pagination.from || 0}</span> മുതൽ <span className="font-weight-bold text-dark">{pagination.to || 0}</span> വരെ കാണിക്കുന്നു
                  </>
                ) : (
                  <>
                    Showing{" "}
                    <span className="font-weight-bold text-dark">
                      {pagination.from || 0}
                    </span>{" "}
                    to{" "}
                    <span className="font-weight-bold text-dark">
                      {pagination.to || 0}
                    </span>{" "}
                    of{" "}
                    <span className="font-weight-bold text-dark">
                      {pagination.total || 0}
                    </span>{" "}
                    proposals
                  </>
                )}
              </div>
              {pagination.last_page > 1 && (
                <div className="d-flex align-items-center">
                  <Pagination
                    currentPage={pagination.current_page}
                    totalCount={pagination.total}
                    pageSize={pagination.per_page}
                    onPageChange={handlePageChange}
                  />
                </div>
              )}
            </div>
          )}

          {mainData && mainData.length > 0 ? (
            <>
              <div className="row">
                {mainData.map((item, index) => (
                  <div key={index} className="col-lg-4 col-md-6 col-sm-12 mb-4">
                    <div
                      className={`card internship-card h-100 border-0 ${isPublicRoute
                        ? "status-border-public"
                        : `status-border-${item.status || "default"}`
                        }`}
                    >
                      <div className="card-body d-flex flex-column p-4">
                        <div className="d-flex justify-content-between align-items-start mb-3 border-bottom pb-2">
                          <div className="flex-grow-1">
                            <h5 className="card-title text-dark font-weight-bold mb-1" style={{ fontSize: "1.1rem" }}>
                              {isPublicRoute &&
                                (item.internship_discipline || "N/A")}
                            </h5>
                            {isPublicRoute && (
                              <>
                                <div className="text-muted text-truncate-custom" style={{ fontSize: "0.8rem", marginTop: "2px" }} title={item.brief_description}>
                                  {item.brief_description || "N/A"}
                                </div>
                              </>
                            )}
                          </div>
                          {!isPublicRoute && (
                            <span
                              className={`badge bg-${getStatusBadgeClass(item.status)} ${item.status === 'pending' ? 'text-dark' : 'text-white'} px-2 py-1`}
                              style={{ fontSize: "0.75rem", borderRadius: "4px" }}
                            >
                              {getStatusText(item.status)}
                            </span>
                          )}
                        </div>

                        <div className="internship-details-container mt-2 mb-3 flex-grow-1" style={{ fontSize: "0.85rem" }}>
                          {isPublicRoute && item.company?.company_name && (
                            <div className="row py-1 align-items-start border-bottom-subtle flex-column flex-sm-row">
                              <div className="col-12 col-sm-5 text-secondary font-weight-bold" style={{ fontSize: "0.8rem" }}>Company Name</div>
                              <div className="col-sm-1 d-none d-sm-block text-muted text-center">:</div>
                              <div className="col-12 col-sm-6 text-dark font-weight-bold">{item.company?.company_name}</div>
                            </div>
                          )}
                          {item.internship_discipline && (
                            <div className="row py-1 align-items-start border-bottom-subtle flex-column flex-sm-row">
                              <div className="col-12 col-sm-5 text-secondary font-weight-bold" style={{ fontSize: "0.8rem" }}>Discipline</div>
                              <div className="col-sm-1 d-none d-sm-block text-muted text-center">:</div>
                              <div className="col-12 col-sm-6 text-dark">{item.internship_discipline}</div>
                            </div>
                          )}
                          {item.brief_description && (
                            <div className="row py-1 align-items-start border-bottom-subtle flex-column flex-sm-row">
                              <div className="col-12 col-sm-5 text-secondary font-weight-bold" style={{ fontSize: "0.8rem" }}>Description</div>
                              <div className="col-sm-1 d-none d-sm-block text-muted text-center">:</div>
                              <div className="col-12 col-sm-6 text-dark text-truncate-custom" title={item.brief_description}>
                                {item.brief_description}
                              </div>
                            </div>
                          )}
                          {item.number_of_students && (
                            <div className="row py-1 align-items-start border-bottom-subtle flex-column flex-sm-row">
                              <div className="col-12 col-sm-5 text-secondary font-weight-bold" style={{ fontSize: "0.8rem" }}>No. of Positions</div>
                              <div className="col-sm-1 d-none d-sm-block text-muted text-center">:</div>
                              <div className="col-12 col-sm-6 text-dark font-weight-bold">{item.number_of_students}</div>
                            </div>
                          )}
                          {item.preferred_start_date && (
                            <div className="row py-1 align-items-start border-bottom-subtle flex-column flex-sm-row">
                              <div className="col-12 col-sm-5 text-secondary font-weight-bold" style={{ fontSize: "0.8rem" }}>Start Date</div>
                              <div className="col-sm-1 d-none d-sm-block text-muted text-center">:</div>
                              <div className="col-12 col-sm-6 text-dark">{formatDate(item.preferred_start_date)}</div>
                            </div>
                          )}
                          {item.preferred_end_date && (
                            <div className="row py-1 align-items-start border-bottom-subtle flex-column flex-sm-row">
                              <div className="col-12 col-sm-5 text-secondary font-weight-bold" style={{ fontSize: "0.8rem" }}>End Date</div>
                              <div className="col-sm-1 d-none d-sm-block text-muted text-center">:</div>
                              <div className="col-12 col-sm-6 text-dark">{formatDate(item.preferred_end_date)}</div>
                            </div>
                          )}
                          {item.grade_criteria && (
                            <div className="row py-1 align-items-start border-bottom-subtle flex-column flex-sm-row">
                              <div className="col-12 col-sm-5 text-secondary font-weight-bold" style={{ fontSize: "0.8rem" }}>Criteria of Selection</div>
                              <div className="col-sm-1 d-none d-sm-block text-muted text-center">:</div>
                              <div className="col-12 col-sm-6 text-dark">{item.grade_criteria}</div>
                            </div>
                          )}
                          {item.additional_certifications && (
                            <div className="row py-1 align-items-start border-bottom-subtle flex-column flex-sm-row">
                              <div className="col-12 col-sm-5 text-secondary font-weight-bold" style={{ fontSize: "0.8rem" }}>Skill Requirement</div>
                              <div className="col-sm-1 d-none d-sm-block text-muted text-center">:</div>
                              <div className="col-12 col-sm-6 text-dark">{item.additional_certifications}</div>
                            </div>
                          )}
                          {(item.qualification_type?.name || getQualificationName(item.qualification_type_id)) && (
                            <div className="row py-1 align-items-start border-bottom-subtle flex-column flex-sm-row">
                              <div className="col-12 col-sm-5 text-secondary font-weight-bold" style={{ fontSize: "0.8rem" }}>Qualification Type</div>
                              <div className="col-sm-1 d-none d-sm-block text-muted text-center">:</div>
                              <div className="col-12 col-sm-6 text-dark">{item.qualification_type?.name || getQualificationName(item.qualification_type_id)}</div>
                            </div>
                          )}
                          {item.qualification_type_parents && getQualificationNamesFromIds(item.qualification_type_parents) !== "--" && (
                            <div className="row py-1 align-items-start border-bottom-subtle flex-column flex-sm-row">
                              <div className="col-12 col-sm-5 text-secondary font-weight-bold" style={{ fontSize: "0.8rem" }}>Streams</div>
                              <div className="col-sm-1 d-none d-sm-block text-muted text-center">:</div>
                              <div className="col-12 col-sm-6 text-dark text-truncate-custom" title={getQualificationNamesFromIds(item.qualification_type_parents)}>
                                {getQualificationNamesFromIds(item.qualification_type_parents)}
                              </div>
                            </div>
                          )}
                          {item.qualification_type_subs && getQualificationNamesFromIds(item.qualification_type_subs) !== "--" && (
                            <div className="row py-1 align-items-start border-bottom-subtle flex-column flex-sm-row">
                              <div className="col-12 col-sm-5 text-secondary font-weight-bold" style={{ fontSize: "0.8rem" }}>Qualifications</div>
                              <div className="col-sm-1 d-none d-sm-block text-muted text-center">:</div>
                              <div className="col-12 col-sm-6 text-dark text-truncate-custom" title={getQualificationNamesFromIds(item.qualification_type_subs)}>
                                {getQualificationNamesFromIds(item.qualification_type_subs)}
                              </div>
                            </div>
                          )}
                          {item.application_last_date && (
                            <div className="row py-1 align-items-start border-bottom-subtle flex-column flex-sm-row">
                              <div className="col-12 col-sm-5 text-danger font-weight-bold" style={{ fontSize: "0.8rem" }}>Last Date</div>
                              <div className="col-sm-1 d-none d-sm-block text-muted text-center">:</div>
                              <div className="col-12 col-sm-6 text-danger font-weight-bold">{formatDate(item.application_last_date)}</div>
                            </div>
                          )}
                          {item.target_category && (
                            <div
                              className="mt-3 p-2 rounded text-muted font-weight-bold"
                              style={{
                                fontSize: "12px",
                                fontStyle: "italic",
                                borderLeft: "3px solid #ffc107",
                                backgroundColor: "#fffbeb",
                                color: "#b45309",
                                lineHeight: "1.4"
                              }}
                            >
                              {getTargetCategoryNB(item.target_category)}
                            </div>
                          )}
                        </div>

                        {(!isSubUser || isPublicRoute) && (
                          <div className="d-flex gap-2 mt-auto">
                            <button
                              className="btn btn-outline-primary flex-grow-1 py-2 font-weight-bold"
                              style={{
                                borderRadius: "6px",
                                fontSize: "13px",
                                borderColor: "#1a233a",
                                color: "#1a233a",
                              }}
                              onClick={() => handleViewDetails(item.id)}
                            >
                              {props.state.language === "ma"
                                ? "വിശദാംശങ്ങൾ"
                                : "View Details"}
                            </button>
                            {isPublicRoute && (
                              <button
                                className="btn btn-success flex-grow-1 py-2 font-weight-bold text-white"
                                style={{
                                  borderRadius: "6px",
                                  fontSize: "13px",
                                  backgroundColor: "#10b981",
                                  borderColor: "#10b981",
                                }}
                                onClick={() => {
                                  sessionStorage.setItem("next_path", "/training-reg");
                                  sessionStorage.setItem("active_path", "/training-reg");
                                  props.history.push("/training-reg");
                                }}
                              >
                                {props.state.language === "ma"
                                  ? "അപ്ലൈ ചെയ്യുക"
                                  : "Apply Now"}
                              </button>
                            )}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
              </div>

              {pagination && pagination.last_page > 1 && (
                <div className="d-flex justify-content-center mt-4">
                  <Pagination
                    currentPage={pagination.current_page}
                    totalCount={pagination.total}
                    pageSize={pagination.per_page}
                    onPageChange={handlePageChange}
                  />
                </div>
              )}
            </>
          ) : (
            <div className="alert alert-info text-center">
              {props.state.language === "ma"
                ? "യാതൊരു ഇന്റേൺഷിപ്പ് പ്രൊപ്പോസലും സമർപ്പിക്കപ്പെട്ടിട്ടില്ല"
                : "No internship proposals found"}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
